import { render, staticRenderFns } from "./ChangeLogList.vue?vue&type=template&id=69415ec6"
import script from "./ChangeLogList.vue?vue&type=script&lang=js"
export * from "./ChangeLogList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports